import {
    Pressable,
    IPressableProps
} from 'native-base';
import { F } from 'ts-toolbelt';
import React from 'react';

export type OurPressableProps = IPressableProps & { onPress?: F.Function; testID?: string }

const OurPressable = (
    props: OurPressableProps,
) => <Pressable
    {...props}
/>;

export default OurPressable;
